export default __webpack_public_path__ + "static/media/summer-intro-background.ad5160bc.png";